import type {
    AutoSegmentationRequest,
    AutoSegmentationResponse,
    ObjectTrackingRequest,
    ObjectTrackingResponse
} from "resha"
import { MainThunkDispatch } from "../../Reducers"
import { apiFetch, apiFetchResponse } from "../Client/NetworkActions"
import { apiEndpoints } from "../../Routes/api"
import { ScopedDataAccess } from "../../Models/Client/DataAccess"
import { reportError } from "../../Helpers/Functions/sentry"

export const processAutoSegmentation =
    (req: AutoSegmentationRequest, dataAccess: ScopedDataAccess) =>
    async (dispatch: MainThunkDispatch): Promise<AutoSegmentationResponse> => {
        const endpoint = apiEndpoints.processAutoSegmentation(dataAccess)
        const res = await dispatch(
            apiFetch<AutoSegmentationResponse>("AUTO_SEGMENTATION", endpoint, {
                method: "POST",
                body: JSON.stringify(req)
            })
        )

        if (res === undefined) {
            throw Error("Request throttled")
        }

        return res
    }

export const createObjectTrackingRequest =
    (req: ObjectTrackingRequest, dataAccess: ScopedDataAccess) =>
    async (dispatch: MainThunkDispatch): Promise<string> => {
        try {
            const createEndpoint =
                apiEndpoints.createObjectTrackingRequest(dataAccess)
            const createResponse = await dispatch(
                apiFetch<{ track_uuid: string }>(
                    String(Math.random()), // never throttle
                    createEndpoint,
                    {
                        method: "POST",
                        body: JSON.stringify(req)
                    }
                )
            )

            if (createResponse === undefined) {
                throw Error("Request throttled")
            }

            return createResponse.track_uuid
        } catch (error) {
            reportError(error)
            throw error
        }
    }

export const getObjectTrackingResult =
    (trackID: string, dataAccess: ScopedDataAccess) =>
    async (
        dispatch: MainThunkDispatch
    ): Promise<ObjectTrackingResponse | undefined> => {
        const getEndpoint = apiEndpoints.getObjectTrackingRequestStatus({
            scope: dataAccess,
            trackID
        })
        const res = await dispatch(
            apiFetchResponse(getEndpoint.url, getEndpoint)
        )

        if (res?.ok) {
            return await (await fetch((await res.json()).track_url)).json()
        }
    }
